import { render, staticRenderFns } from "./DeveloperIntegrations.vue?vue&type=template&id=5aa785b6&scoped=true"
import script from "./DeveloperIntegrations.vue?vue&type=script&lang=js"
export * from "./DeveloperIntegrations.vue?vue&type=script&lang=js"
import style0 from "./DeveloperIntegrations.vue?vue&type=style&index=0&id=5aa785b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa785b6",
  null
  
)

export default component.exports